import { lazy, Suspense } from "react";
import Loader from '../customs/spinner/spinner';

const Main = lazy(() => import('../components/confirmAuthOTP/main'));

const ConfirmAuthOTP = () => {
    return (
            <Suspense fallback={<Loader color="#E57D1E"/>}>
                <Main/>
            </Suspense>
    )
}

export default ConfirmAuthOTP;